import { render } from "./upload-file.vue?vue&type=template&id=4539ac3d&scoped=true"
import script from "./upload-file.vue?vue&type=script&lang=js"
export * from "./upload-file.vue?vue&type=script&lang=js"

import "./upload-file.vue?vue&type=style&index=0&id=4539ac3d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4539ac3d"

export default script